var Backbone = require('backbone');


module.exports = Backbone.Model.extend({

    idAttribute: 'code', // define to prevent dupes in collection; in reality would only ever occur from fixtures/node server

    defaults: {

        code: null,
        description: null,

        /* introduced in schema 9.3.5 -- will all be null and considered active in older schemas */
        active: null, /* convenience; not a DB field */
        startDate: null,
        endDate: null,
        creationUser: null,
        creationTime: null,
        modifiedUser: null,
        modifiedTime: null

    },

    /**
     * Used in SAT filter.
     * Note: case insensitive by default -- could put in param for this is desired
     * If perf is ever an issue, could cache the combo'd text value and set on model parse
     */
    codeOrDescriptionContainsText: function(text) {
        return ( (this.get('code') + this.get('description') ).toLowerCase() )
                .indexOf( text.toLowerCase() ) > -1;
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/reasonCodes/model.js
 ** module id = 81
 ** module chunks = 0
 **/